import { render, staticRenderFns } from "./RepairDailyWageReports.vue?vue&type=template&id=3cc3b524&"
import script from "./RepairDailyWageReports.vue?vue&type=script&lang=ts&"
export * from "./RepairDailyWageReports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports